import React from "react";
import styled, { useTheme } from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const StyledContainer = styled.div`
  /* height: ${({ height }) => (height ? `${height}px` : `unset`)}; */
`;

const EmptyResults = ({
  children,
  height = null,
  icon = "",
  iconSize = "3x",
  iconColor = "",
  ...restProps
}) => {
  const theme = useTheme();
  return (
    <StyledContainer height={height} className={`${restProps.className}`}>
      <div className="d-flex flex-column align-items-center">
        <FontAwesomeIcon
          icon={icon || faSearch}
          size={iconSize}
          color={iconColor || theme.primary}
          className="mt-2 mb-4"
        />
        <h6 className="fw-bold">{children}</h6>
      </div>
    </StyledContainer>
  );
};

export default EmptyResults;
